import { render, staticRenderFns } from "./supplierBudget.vue?vue&type=template&id=2af0339c&"
import script from "./supplierBudget.vue?vue&type=script&lang=js&"
export * from "./supplierBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports